
import { baseApi } from "./apiConfig.js";
import { store } from "@/store/store.js";
// import purchaseProfileUser from "@/components/bid/apiResponse/purchaseprofileuserinput.js";
export const getPropertyDetail = async (data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getPropertyDetail/${data}`
    );

    return response.data;
  } catch (error) {
    console.error("error while getting getPropertyDetail", error);
    throw error;
  }
  // Todo:use when server is down(when 503 error occur)
  // return new Promise((resolve) => {
  //   resolve(propertyDetail);
  // });
};

export const getUserProfile = async () => {
  try {
    const loadTiming = new Date().getTime();
    const response = await baseApi.get(
      `/portal/lean-regn/getUserProfile?${loadTiming}`
    );
    // console.log("response data from userProfileData ", response);
    return response.data;
  } catch (error) {
    console.error("error while getting getUserProfile", error);
    throw error;
  }
  // Todo:use when server is down(when 503 error occur)
  // return new Promise((resolve) => {
  //   resolve(userprofile);
  // });
};

export const saveBuyerProfile = async (payload) => {
  try {
    const loadTiming = new Date().getTime();

    const response = await baseApi.post(
      `/portal/lean-regn/saveBuyerProfile?${loadTiming} `,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("error while getting saveBuyerProfile", error);
    throw error;
  }
};

export const stateListData = async () => {
  try {
    const response = await baseApi.get(`/portal/stateLists`);
    // console.log("response data from stateList ->", response);
    return response;
  } catch (error) {
    console.error("api stateListData error:", error);
    throw error;
  }
  // Todo:use when server is down(when 503 error occur)
  // return new Promise((resolve) => {
  //   resolve(stateList);
  // });
};

export const UserProfileVerificationDetails = async () => {
  try {
    const loadTiming = new Date().getTime();

    const response = await baseApi.get(
      `/portal/lean-regn/getUserProfileVerificationDetails?timeStamp=${loadTiming}`
    );
    // console.log("response data from userProfileVerificationDetails ", response);
    return response.data;
  } catch (error) {
    console.error("api UserProfileVerificationDetails error:", error);
    throw error;
  }
  // Todo:use when server is down(when 503 error occur)
  // return new Promise((resolve) => {
  //   resolve(getUserProfileVerificationDetails);
  // });
};

export const cityList = async (data) => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/cityListForState?state=${data}`
    );
    // console.log("response data from cityList ", response);
    return response;
  } catch (error) {
    console.error("api cityList error:", error);
    throw error;
  }
  // Todo:use when server is down(when 503 error occur)
  // return new Promise((resolve) => {
  //   resolve(listofCity);
  // });
};

//! AGENT PROFILE INFORMATION FLOWS

export const isAgentHasActiveBidsAndOffer = async () => {
  try {
    const response = await baseApi.post(
      "/portal/user/isAgentHasActiveBidsAndOffers"
    );
    return response;
  } catch (error) {
    console.error("api isAgentHasActiveBidsAndOffer error:", error);
    throw error;
  }
};

export const verifyLicenseDetails = async (licNo, stateid) => {
  try {
    const response = await baseApi.get(
      `/portal/verifyLicenseDetails?licenseNumber=${licNo}&stateId=${stateid}`
    );
    return response;
  } catch (error) {
    console.error("api verifyLicenseDetails error:", error);
    throw error;
  }
};

export const insertLicence = async (payload) => {
  try {
    const response = await baseApi.post("/portal/user/insertLicense", payload);
    return response;
  } catch (error) {
    console.error("api insertLicence error:", error);
    throw error;
  }
};
export const allLicenceDetails = async () => {
  try {
    const response = await baseApi.post("/portal/lean-regn/allLicenceDetails");
    return response.data;
  } catch (error) {
    console.error("api allLicenceDetails error:", error);
    throw error;
  }
};

export const editLicenceDetail = async (licenceId) => {
  try {
    const response = baseApi.get(
      `/portal/user/getLicenseDetails?licenseId=${licenceId}`
    );
    return response;
  } catch (error) {
    console.error("api editLicenceDetail error:", error);
    throw error;
  }
};
export const updateLicenceDetail = async (payload) => {
  try {
    const response = await baseApi.post("/portal/user/updateLicense", payload);
    return response;
  } catch (error) {
    console.error("api updateLicenceDetail error:", error);
    throw error;
  }
};
export const deleteLicenceDetail = async (licenseId) => {
  try {
    const response = await baseApi.post(
      `/portal/user/deleteLicense?licenseId=${licenseId}`,
      { currLicenseId: licenseId }
    );
    return response;
  } catch (error) {
    console.error("api deleteLicenceDetail error:", error);
    throw error;
  }
};
export const checkSmsFeature = async (state) => {
  try {
    const response = await baseApi.post(
      `/portal/lean-regn/isSmsFeatureEnabled/${state}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const insertCorporateLicence = async (payload) => {
  try {
    const response = baseApi.post(
      "/portal/lean-regn/insertCorpLicense",
      payload
    );
    return response;
  } catch (error) {
    console.error("api insertCorporateLicence error:", error);
    throw error;
  }
};
export const deleteCorporateLicence = async (corporateId) => {
  try {
    const response = await baseApi.post(
      `/portal/lean-regn/deleteCorpLicense?licenseId=${corporateId}`
    );
    return response;
  } catch (error) {
    console.error("api deleteCorporateLicence error:", error);
    throw error;
  }
};

export const editCorporateDetail = async (licenceId) => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/getCorpLicenseDetails?licenseId=${licenceId}`
    );
    return response;
  } catch (error) {
    console.error("api editCorporateDetail error:", error);
    throw error;
  }
};
export const updateCorporateLicence = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/lean-regn/updateCorpLicense`,
      payload
    );
    return response;
  } catch (error) {
    console.error("api updateCorporateLicence error:", error);
    throw error;
  }
};
export const saveUserDetails = async (payload) => {
  try {
    const loadTiming = new Date().getTime();

    const response = await baseApi.post(
      `/portal/lean-regn/saveUserDetails?${loadTiming}`,
      payload
    );
    return response;
  } catch (error) {
    console.error("api saveUserDetails error:", error);
    throw error;
  }
};

export const verifyUserProfile = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/lean-regn/verifyUserProfile`,
      payload
    );
    return response;
  } catch (error) {
    console.error("api verifyUserProfile error:", error);
    throw error;
  }
};
export const getPurchaseProfileUser = async (payload) => {
  try {
    // ! get request
    // const response = await baseApi.get("/portal/getCifTemplatesByUserId");
    // return response;

    // const response = await baseApi.get(
    //   `/portal/getCifTemplatesByUserId?listingId=${payload}`
    // );
    const response = await baseApi.post(
      "/portal/getCifTemplatesByUserId",
      payload
    );

    return response;
  } catch (error) {
    console.error("api getPurchaseProfileUser error:", error);
    throw error;
  }
};

export const getPurchaseProfileByUserId = async () => {
  const state = store.getState();

  try {
    const userID = state?.user?.user?.realbidUserId;
    const response = await baseApi.post("/portal/getCifTemplatesByUserId", {
      userId: userID,
    });
    return response
  } catch (error) {
    console.error("api getPurchaseProfileUser error:", error);
    throw error;
  }
};

export const isPhoneNoInUse = async (data) => {
  try {
    const response = await baseApi.get(
      `/portal/isPhoneNumberInUse?phoneNumber=${data}`
    );
    return response;
  } catch (error) {
    console.error("api isPhoneNoInUse error:", error);
    throw error;
  }
};

export const isPhoneNoVerified = async (data) => {
  try {
    const response = await baseApi.get(
      `/portal/isPhoneNumberVerified?phoneNumber=${data}`
    );
    return response;
  } catch (error) {
    console.error("api isPhoneNoVerified error:", error);
    throw error;
  }
};

export const getCIFConfiguration = async (data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/cif/fileUploadConfig/${data}/CIF`
    );
    // /portal/v2.0/cif/fileUploadConfig/879711202510AUCN2/CIF
    return response;
  } catch (error) {
    console.error("api getCIFConfiguration error:", error);
    throw error;
  }
};
// /portal/copyFilesFromTemplateToCif
export const copyFilesFromTemplateToCif = async (data) => {
  try {
    const response = await baseApi.post(
      `/portal/copyFilesFromTemplateToCif`,
      data
    );
    return response;
  } catch (error) {
    console.error("api copyFilesFromTemplateToCif error:", error);
    throw error;
  }
};
// /portal/v2.0/getBidDepositDetails
export const getBidDepositDetail = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/v2.0/getBidDepositDetails`,
      payload
    );
    return response;
  } catch (error) {
    console.error("api getBidDepositDetail error:", error);
    throw error;
  }
};
// In bid.js, add this new function

export const validateAddress = async (addressData) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/isValidAddress",
      addressData
    );
    return response;
  } catch (error) {
    console.error("api validateAddress error:", error);
    throw error;
  }
};

export const cifVerifyLicenseDetails = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/ci/verifyLicenseDetails`,
      payload
    );
    return response;
  } catch (error) {
    console.error("api cifVerifyLicenseDetails error:", error);
    throw error;
  }
};


export const uploadFile = async (formData) => {
  try {
    const response = await baseApi.post("/portal/cif/uploadFile", formData);
    return response;
  } catch (error) {
    console.error("api uploadFile error:", error);
    throw error;
  }
};


// In bid.js
export const uploadFileCIF = async (file, fileUploadRequest) => {
  // try {
  //   const response = await baseApi.post("/portal/cif/uploadFile", file);
  //   return response;
  // } catch (error) {
  //   console.error("api uploadFileCIF error:", error);
  //   throw error;
  // }

  // const formData = new FormData();
  // formData.append('file', file);

  var fileUploadUrl = "";
  if (fileUploadRequest?.isPurchaseProfile) {
    fileUploadUrl = `/portal/app/template/uploadFile?templateId=${fileUploadRequest.templateId}&fileCategory=${fileUploadRequest.fileCategory}&fileSubCategory=${fileUploadRequest.fileSubCategory}`;
  } else {
    // fileUploadUrl = `/portal/uploadCifFile?listingId=${fileUploadRequest.listingId}&fileCategory=USER_FUND_PROOF`;
    fileUploadUrl = `/portal/uploadCifFile?listingId=${fileUploadRequest.listingId}&fileCategory=${fileUploadRequest.fileCategory}`;
    // Add fileSubCategory parameter only if it exists (CWCOT case)
    if (fileUploadRequest.fileSubCategory) {
      fileUploadUrl += `&fileSubCategory=${fileUploadRequest.fileSubCategory}`;
    }
  }

  // Response from uploadFile will include ID to use for file removal.
  return baseApi
    .post(fileUploadUrl, file)
    .then((response) => {
      console.log("file uploaded successfully!", response);
      // delete file....›
      if (response.data) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch((e) => {
      console.log("error uploading file!", e);
      return null;
    });
};
// /portal/cif/deleteFile/00017163354AUCN1/D_60443619244013
export const deleteFile = async (fileId, id) => {
  try {
    const response = await baseApi.post(
      `/portal/cif/deleteFile/${id}/${fileId}`
    );
    return response;
  } catch (error) {
    console.error("api deleteFile error:", error);
    throw error;
  }
};


export const getBidCMS = (path) => {
  return baseApi
    .get(
      encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
    )
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};
export const getFinanceListType = () => {
  return baseApi
    .get(
      encodeURI(
        'portal/get-new-cms-data/hubzuweb?template=/hubzuweb/pages/bidWizard/accordions/financingAndClosingData/financingBlockForm/financingTypeList',
      ),
    )
    .then(response => {
      if (response.status === 200) {
        return response?.data?.results?.length > 0 ? response.data.results[0] : [];
      }
      return null;
    });
};
// export const uploadFile = async (file, fileUploadRequest) => {

//   if (
//     Platform.OS === 'ios' &&
//     (file.type === 'image/jpeg' || file.type === 'image/jpg') &&
//     (file.name.indexOf('.PNG') > -1 || file.name.indexOf('.png') > -1)
//   ) {
//     let extension = file?.type?.split('/') || [];
//     extension = extension[1] || 'jpg';
//     file.name = file.name.replace(/\.[^/.]+$/, '') + '.' + extension;
//   }

//   const formData = new FormData();
//   formData.append('file', file);

//   var fileUploadUrl = '';
//   if (fileUploadRequest?.isPurchaseProfile) {
//     fileUploadUrl = `/portal/app/template/uploadFile?templateId=${fileUploadRequest.templateId
//       }&fileCategory=${fileUploadRequest.fileCategory}&fileSubCategory=${fileUploadRequest.fileSubCategory
//       }`;
//   } else {
//     fileUploadUrl = `/portal/uploadCifFile?listingId=${fileUploadRequest.listingId
//       }&fileCategory=${fileUploadRequest.fileCategory}&fileSubCategory=${fileUploadRequest.fileSubCategory
//       }`;
//   }

//   // Response from uploadFile will include ID to use for file removal.
//   return baseApi
//     .post(fileUploadUrl, formData)
//     .then(response => {
//       log('file uploaded successfully!', response);
//       // delete file....›
//       if (response.data) {
//         return response.data;
//       } else {
//         return null;
//       }
//     })
//     .catch(e => {
//       log('error uploading file!', e);
//       return null;
//     });
// };

// Modified upload function

export const saveCIFTemplate = async (cifData) => {
  try {
    //buyurl
    const response = await baseApi.post("/portal/cif-template/save", cifData);
    return response;
  } catch (error) {
    console.error("api saveCIFTemplate error:", error);
    throw error;
  }
};

export const saveCif = async (cifData) => {
  try {
    //coreqeurl
    const response = await baseApi.post("/portal/v2.0/cif/save", cifData);
    return response;
  } catch (error) {
    console.error("api saveCif error:", error);
    throw error;
  }
};
// /portal/v2.0/cif/save
// In bid.js

export const getTemplateDocuments = async (templateId) => {
  try {
    const response = await baseApi.post(
      `/portal/template/documents/${templateId}`
    );
    return response;
  } catch (error) {
    console.error("api getTemplateDocuments error:", error);
    throw error;
  }
};
export const bidWizardPage = async (data) => {
  try {
    const response = await baseApi.post(`/portal/v2.0/bidWizard`, data);
    return response;
  } catch (error) {
    console.error("api bidWizardPage error:", error);
    throw error;
  }
};

export const getCifPageDetail = async (data) => {
  try {
    const response = await baseApi.get(`/portal/v2.0/cifPageDetail/${data}`);
    return response;
  } catch (error) {
    console.error("api getCifPageDetail error:", error);
    throw error;
  }
};

export const getCifDocuments = async (data) => {
  try {
    // /portal/cif/documents/1e6930ae-371f-4aed-8b62-a28226004e27?_=1743572788162
    const loadTiming = new Date().getTime();
    const response = await baseApi.get(
      `/portal/cif/documents/${data}?_=${loadTiming}`
    );
    return response;
  } catch (error) {
    console.error("api getCifDocuments error:", error);
    throw error;
  }
};

//https://buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/getCifTemplatesByUserId
//https://buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/lean-regn/cityListForState?state=IL ===>GET
// https://buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/isPhoneNumberInUse?phoneNumber=2380320923===>GET
//https://buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/isPhoneNumberVerified?phoneNumber=2380320923===>GET
//https://buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/lean-regn/isValidAddress ====>POST
//buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/getCifTemplatesByUserId

export const sendVerificationCode = async (data) => {
  try {
    const response = await baseApi.post(`/portal/sendVerificationCode`, data);
    return response.data;
  } catch (error) {
    console.error("api send verification error:", error);
    throw error;
  }
};
